// @ts-nocheck
import ActionTypes from "../constants/actions";
import Immutable from "immutable";
import _ from "lodash";

const defaultState = new Immutable.Map({});

export default (state = defaultState, action) => {
  switch (action.type) {
    case ActionTypes.SET_TEAM_DIVISION_BY_DIVISION:
      _.map(action.teamDivisions, team => {
        state = state.set(team._id, team);
      });
      return state;
      break;
    case ActionTypes.UPDATE_TEAM_DIVISION:
    case ActionTypes.ADD_TEAM_DIVISION:
      return state.set(action.teamDivision._id, action.teamDivision);
      break;
    case ActionTypes.DELETE_TEAM_DIVISION:
      return state.remove(action.teamDivision._id);
      break;
    default:
      return state;
  }
};
